import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/seo/rankings/service-pages`;
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('adminToken')}` });

const Delta = ({ cur, prev, lowerIsBetter = false, testId }) => {
  if (cur == null && prev == null) return <span className="text-gray-400">–</span>;
  const diff = (cur || 0) - (prev || 0);
  const good = lowerIsBetter ? diff < 0 : diff > 0;
  const shown = lowerIsBetter ? Math.abs(diff).toFixed(1) : Math.abs(diff);
  return (
    <span data-testid={testId}>
      <span className="font-semibold text-gray-900">{cur ?? '–'}</span>
      {prev != null && diff !== 0 && (
        <span className={`ml-1.5 text-xs font-semibold ${good ? 'text-emerald-700' : 'text-rose-700'}`}>
          {good ? '▲' : '▼'} {shown}
        </span>
      )}
      <span className="block text-[11px] text-gray-400">was {prev ?? '–'}</span>
    </span>
  );
};

export default function ServicePagesCard() {
  const [data, setData] = useState(null);
  useEffect(() => {
    axios.get(API, { headers: authHeaders() }).then((r) => setData(r.data)).catch(() => setData({ ok: false, error: 'Could not load service pages' }));
  }, []);
  if (!data) return <div className="bg-white rounded-lg shadow p-5 text-sm text-gray-500">Loading service pages…</div>;
  if (!data.ok) return <div className="bg-white rounded-lg shadow p-5 text-sm text-rose-700" data-testid="service-pages-error">{data.error}</div>;
  return (
    <div className="bg-white rounded-lg shadow p-5" data-testid="service-pages-card">
      <h3 className="text-lg font-bold text-gray-900">Money pages: last 28 days vs the 28 before</h3>
      <p className="text-sm text-gray-600 mb-4">How the pages that sell your services are moving in Google. Position: lower is better. ({data.range?.[0]} to {data.range?.[1]})</p>
      <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[560px]">
          <thead>
            <tr className="text-left text-xs uppercase tracking-wider text-gray-500 border-b">
              <th className="py-2 pr-3">Page</th><th className="py-2 pr-3">Clicks</th><th className="py-2 pr-3">Impressions</th><th className="py-2">Avg position</th>
            </tr>
          </thead>
          <tbody>
            {data.rows.map((r) => (
              <tr key={r.page} className="border-b last:border-0" data-testid={`service-page-row-${r.page.replace(/\//g, '') || 'home'}`}>
                <td className="py-2.5 pr-3"><a href={`https://audioandco.com${r.page}`} target="_blank" rel="noopener noreferrer" className="text-[#A7468A] hover:underline">{r.page}</a></td>
                <td className="py-2.5 pr-3"><Delta cur={r.clicks} prev={r.prev_clicks} /></td>
                <td className="py-2.5 pr-3"><Delta cur={r.impressions} prev={r.prev_impressions} /></td>
                <td className="py-2.5"><Delta cur={r.position} prev={r.prev_position} lowerIsBetter /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
